import { render, staticRenderFns } from "./ReservationModal.vue?vue&type=template&id=053363e0&scoped=true"
import script from "./ReservationModal.vue?vue&type=script&lang=js"
export * from "./ReservationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053363e0",
  null
  
)

export default component.exports